"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrg = createOrg;
exports.deleteOrg = deleteOrg;
exports.getOrgAll = getOrgAll;
exports.getOrgList = getOrgList;
exports.updateOrg = updateOrg;
var _request = _interopRequireDefault(require("@/utils/request"));
function getOrgAll() {
  return (0, _request.default)({
    url: '/system/organization/',
    method: 'get'
  });
}
function getOrgList(query) {
  return (0, _request.default)({
    url: '/system/organization/',
    method: 'get',
    params: query
  });
}
function createOrg(data) {
  return (0, _request.default)({
    url: '/system/organization/',
    method: 'post',
    data: data
  });
}
function updateOrg(id, data) {
  return (0, _request.default)({
    url: "/system/organization/".concat(id, "/"),
    method: 'put',
    data: data
  });
}
function deleteOrg(id) {
  return (0, _request.default)({
    url: "/system/organization/".concat(id, "/"),
    method: 'delete'
  });
}